import React from "react";
var __jsx = React.createElement;
import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
function LoadingView() {
  return /*#__PURE__*/React.createElement("div", {
    className: "flex flex-1 items-center justify-center gap-3 text-gray-400"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faSpinnerThird,
    className: "animate-spin text-lg"
  }));
}
export default LoadingView;